import type { Rec, CompKey } from "@shared/types.js";

/** Display order for the six reporting components (Cat. E folds into Accommodation). */
export const COMP_ORDER: CompKey[] = [
  "accommodation", "activity", "entrance_fee", "transport", "guide", "train",
];

export const COMP_LABEL: Record<CompKey, string> = {
  accommodation: "Accommodation",
  activity: "Activities",
  entrance_fee: "Entrance Fee",
  transport: "Transportation",
  guide: "Guide Fee",
  train: "Train",
  cat_e: "Cat. E sheet",
};

/** Icon per component, so a component reads the same in every panel. */
export const COMP_ICON: Record<CompKey, string> = {
  accommodation: "bi-building",
  activity: "bi-compass",
  entrance_fee: "bi-ticket-perforated",
  transport: "bi-bus-front",
  guide: "bi-person-badge",
  train: "bi-train-front",
  cat_e: "bi-collection",
};

export const CATS = ["A", "B", "C", "D", "E"] as const;

/** Rows belonging to one reporting component; Cat. E counts as Accommodation. */
export function compRows(rows: Rec[], c: CompKey): Rec[] {
  return rows.filter((r) => r.comp === c || (c === "accommodation" && r.comp === "cat_e"));
}
